import { render, staticRenderFns } from "./td_remark.vue?vue&type=template&id=daf95d6c&scoped=true"
import script from "./td_remark.vue?vue&type=script&lang=js"
export * from "./td_remark.vue?vue&type=script&lang=js"
import style0 from "./td_remark.vue?vue&type=style&index=0&id=daf95d6c&prod&lang=scss&scoped=true"
import style1 from "./td_remark.vue?vue&type=style&index=1&id=daf95d6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf95d6c",
  null
  
)

export default component.exports